/* ============================================================================
   LIG — "Put my design on more" (custom-orders gallery)

   Pairs to the customer's job with NOTHING but the order_id already in the URL
   (Mike, 2026-07-25: "when they click it, it recognizes what page they're on
   from the URL parameter and pre-fills that in and that's how it pairs it with
   that person's particular order"). No login, no token, no typing.

   The middleware side is deliberately inert — it records the ask and pings the
   Custom Terminal; it can't charge or print. See api/custom-addon.ts.
   ============================================================================ */
(function () {
  'use strict';

  var script = document.currentScript;
  var API = ((script && script.getAttribute('data-api')) || '').replace(/\/$/, '');

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var modal = document.querySelector('[data-ca-modal]');
    var cta = document.querySelector('[data-ca-cta]');
    if (!modal || !cta) return;

    // The order number IS the pairing key — same param the gallery already uses.
    var params = new URLSearchParams(window.location.search);
    var orderId = (params.get('order_id') || params.get('order') || '').trim();
    if (!/^\d{2,12}$/.test(orderId)) return; // no order in the URL → nothing to attach to

    var grid = modal.querySelector('[data-ca-items]');
    var noteEl = modal.querySelector('[data-ca-note]');
    var hpEl = modal.querySelector('[data-ca-hp]');
    var countEl = modal.querySelector('[data-ca-count]');
    var sendBtn = modal.querySelector('[data-ca-send]');
    var doneEl = modal.querySelector('[data-ca-done]');
    var picked = Object.create(null);
    var loaded = false;
    var lastFocus = null;

    cta.hidden = false;

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
    function names() { return Object.keys(picked).filter(function (k) { return picked[k]; }); }
    function sync() {
      var n = names().length;
      countEl.textContent = n ? (n + (n === 1 ? ' item picked' : ' items picked')) : 'Nothing picked yet';
      sendBtn.disabled = !n;
    }

    function loadItems() {
      if (loaded) return;
      loaded = true;
      fetch(API + '/api/custom-addon')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d && d.items) || [];
          if (!items.length) { grid.innerHTML = '<p class="lig-ca-loading">Tell us below what you\'d like and we\'ll take it from there.</p>'; return; }
          grid.innerHTML = items.map(function (it) {
            return '<label class="lig-ca-item" data-lbl="' + esc(it.label) + '">' +
              '<input type="checkbox" value="' + esc(it.label) + '" />' +
              '<span class="box" aria-hidden="true">✓</span>' +
              '<span class="nm">' + esc(it.label) + '</span>' +
              (it.from ? '<span class="pr">' + esc(it.from) + '</span>' : '') +
              '</label>';
          }).join('');
          grid.querySelectorAll('.lig-ca-item').forEach(function (el) {
            var cb = el.querySelector('input');
            cb.addEventListener('change', function () {
              picked[cb.value] = cb.checked;
              el.classList.toggle('is-on', cb.checked);
              sync();
            });
          });
        })
        .catch(function () {
          grid.innerHTML = '<p class="lig-ca-loading">Tell us below what you\'d like and we\'ll take it from there.</p>';
        });
    }

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      loadItems();
      var x = modal.querySelector('[data-ca-close]');
      if (x && x.focus) setTimeout(function () { x.focus(); }, 30);
    }
    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.querySelectorAll('[data-ca-open]').forEach(function (b) { b.addEventListener('click', open); });
    modal.querySelectorAll('[data-ca-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

    sendBtn.addEventListener('click', function () {
      var items = names();
      if (!items.length) return;
      sendBtn.disabled = true;
      var label = sendBtn.textContent;
      sendBtn.textContent = 'Sending…';
      fetch(API + '/api/custom-addon', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          order_id: orderId,
          items: items,
          note: (noteEl && noteEl.value) || '',
          website: (hpEl && hpEl.value) || ''
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d || d.ok !== true) throw new Error((d && d.reason) || 'failed');
          // Always thank them: even when we couldn't match the order, a human
          // sees the Slack ping. Never expose whether the order resolved.
          modal.querySelector('.lig-ca-grid').hidden = true;
          modal.querySelectorAll('.lig-ca-label, .lig-ca-note, .lig-ca-actions, .lig-ca-fine').forEach(function (el) { el.hidden = true; });
          doneEl.hidden = false;
          doneEl.innerHTML = '<h3>Got it — thank you.</h3><p>We\'ll add ' +
            (items.length === 1 ? 'that piece' : 'those pieces') +
            ' to your design and email you when they\'re ready on your page.</p>';
        })
        .catch(function () {
          sendBtn.disabled = false;
          sendBtn.textContent = label;
          alert("That didn't go through — mind trying once more, or just reply to your order email?");
        });
    });

    sync();
  });
})();
